import { render, staticRenderFns } from "./PromotionCodes.vue?vue&type=template&id=2ade18c8&scoped=true&"
import script from "./PromotionCodes.vue?vue&type=script&lang=js&"
export * from "./PromotionCodes.vue?vue&type=script&lang=js&"
import style0 from "./PromotionCodes.vue?vue&type=style&index=0&id=2ade18c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ade18c8",
  null
  
)

export default component.exports